<div class="notification fade-in {{htmlClass}}" *ngIf="visible">
  <div class="content">
    <span class="material-symbols-rounded">{{actionIcon}}</span>
    <!--   To use '| langf' pipe insert preserved words like '{LANG:scope|l}'  -->
    <span>{{snackbarEvent.message | langf}}</span>
  </div>
  <span class="material-symbols-rounded close-icon" *ngIf="snackbarEvent.permanent" (click)="close()">close</span>
</div>
